import React, { FC } from 'react'
import {
  BugtrackerConfig,
  FormProjectField,
  ProjectField,
  ProjectFieldTypes
} from '../../api/shared'
import { DefaultUserField } from './default-user-field'
import { css } from '@emotion/css'
import { TextBox } from '../../../../../legacy-design-system/form-text-box'
import { LabelsField } from './arrays/labels-field'
import { NumberField } from './number-field'
import { ArraysField } from './arrays/arrays-field'
import { DateField } from './date-field'
import { StringField } from './string-field'
import { AllowedValuesField } from './allowed-values-field'
import { useIntl } from 'react-intl'

export const isSupportedJiraField = (field: ProjectField) => {
  return (
    field &&
    field.schema &&
    (field.schema.type === 'user' ||
      field.schema.type === 'number' ||
      field.schema.type === 'array' ||
      field.schema.type === 'date' ||
      field.schema.type === 'string' ||
      field.schema.type === 'timetracking' ||
      field.schema.type === 'any' ||
      field.schema.type === 'option' ||
      field.schema.type === 'select' ||
      field.schema.type === 'url')
  )
}

export const isUnsupportedJiraField = (field: ProjectField) => {
  return !field || !field.schema || !!field.empty
}

export interface JiraFieldDefaultValueProps {
  bugtracker?: BugtrackerConfig
  field: FormProjectField
  updateValue: (value: any) => void
}

export const JiraFieldDefaultValue: FC<JiraFieldDefaultValueProps> = (
  props: JiraFieldDefaultValueProps
) => {
  const { formatMessage } = useIntl()
  const { field } = props
  //  Remove placeholder stub and implement this
  //  See https://contrast.atlassian.net/browse/INT-955
  //  See https://contrast.atlassian.net/browse/INT-957
  //  See https://contrast.atlassian.net/browse/INT-954

  switch (field.type) {
    case ProjectFieldTypes.USER:
      return <DefaultUserField {...props} />
    case ProjectFieldTypes.ARRAY:
      // eslint-disable-next-line unicorn/prefer-ternary
      if (field.key === 'labels') {
        return <LabelsField {...props} />
      } else {
        return <ArraysField {...props} />
      }
    case ProjectFieldTypes.NUMBER:
      return <NumberField {...props} />
    case ProjectFieldTypes.DATE:
      return <DateField {...props} />
    case ProjectFieldTypes.STRING:
    case ProjectFieldTypes.TIME_TRACKING:
    case ProjectFieldTypes.ANY:
    case ProjectFieldTypes.URL:
      return <StringField {...props} />
    case ProjectFieldTypes.OPTION:
      return <AllowedValuesField {...props} />
    case ProjectFieldTypes.SELECT:
      return <AllowedValuesField {...props} />
    case ProjectFieldTypes.CASCADING_SELECT:
      return <AllowedValuesField {...props} />
    default:
      break
  }

  return (
    <TextBox
      data-testid="jira-field-default-empty-value"
      className={css`
        width: auto;
      `}
      disabled={true}
      value={
        field.type &&
        formatMessage(
          {
            id: 'detail_integrationSettings_unsupportedField_react'
          },
          { value: props.field._projectField?.name }
        )
      }
    />
  )
}
